<form [formGroup]="ruleForm">
  <datalean-container [structureFields]="ruleList" [id]="'RULE_LIST'"></datalean-container>
</form>
